import { motion } from "framer-motion";

const TESTIMONIALS = [
  {
    quote: "Jessica is the most enjoyable, effective trainer I've had in a long time. She understands your limitations but will push you just enough so that you get closer to your goals. Recommend 15/10!",
    author: "Private client",
  },
  {
    quote: "Jess has converted me to the power of Pilates! She's excellent at explaining each exercise and ensuring I fully understand the move, where I should feel it, and its benefits. After each class I feel not only fully worked out, but educated. Her playlists are fantastic and her infectiously positive personality makes me look forward to each session.",
    author: "Private client",
  },
  {
    quote: "We are so grateful to have found Jessica. Over three months of working with her I saw my mum lose weight, gain strength and walk more briskly than she ever has before. Jessica understood her needs and tailored every single exercise to her.",
    author: "Daughter of a private client",
  },
];

export default function Testimonials() {
  return (
    <section id="testimonials" data-testid="testimonials-section" className="bg-[#F3EDE2] py-24 sm:py-32 lg:py-40">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-3">
            <p className="eyebrow label text-[#2D4A3E] mb-6">Client words</p>
            <h2 className="font-display text-4xl sm:text-5xl leading-[1.05] tracking-tight text-[#1C1917]">
              In their words.
            </h2>
          </div>

          <div className="lg:col-span-9 space-y-6">
            {TESTIMONIALS.map((t, i) => (
              <motion.figure
                key={i}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.12 }}
                data-testid={`testimonial-card-${i}`}
                className="relative rounded-3xl bg-[#FAF7F2] border border-[#1C1917]/10 p-8 sm:p-10 shadow-[0_30px_60px_-50px_rgba(28,25,23,0.5)]"
              >
                <span aria-hidden="true" className="font-display text-6xl leading-none text-[#C5A059] block mb-2">“</span>
                <blockquote data-testid={`testimonial-quote-${i}`} className="font-display text-xl sm:text-2xl leading-[1.4] tracking-tight text-[#1C1917] -mt-6">
                  {t.quote}
                </blockquote>
                <figcaption data-testid={`testimonial-author-${i}`} className="mt-6 flex items-center gap-3">
                  <span className="h-px w-8 bg-[#C5A059]" />
                  <span className="label text-[#57534E]">{t.author}</span>
                </figcaption>
              </motion.figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
